module.exports = __webpack_public_path__ + "img/thumbnail_Nyala_f_albino.b369a85b.png";